<div class="row mb-4">
    <p class="mb-1 total" style="text-align: right; margin-top: -20px; padding-right: 12px;">Mis cursos
        <strong>{{totalProducts}}</strong>
    </p>
    <div class="col-xs-12 col-sm-12">
        <div class="action d-flex justify-content-end align-items-center">
            <div class="d-flex align-items-center" style="flex: 1; margin-right: 10px;">
                <div style="flex: 0.9; margin-right: 10px;">
                    <label class="sr-only">Buscar por ítulo del curso</label>
                    <div class="input-group" style="width: 100%;">
                        <input type="text" class="form-control" style="width: 100%;" [(ngModel)]="search"
                            (ngModelChange)="updateSearchValue($event)" [ngModelOptions]="{standalone: true}"
                            (keyup)="loadData()" placeholder="Buscar por título del curso">
                    </div>
                </div>
                <!-- <select class="form-control" style="flex: 0.2; margin-right: 10px;" [(ngModel)]="selectedStatus" (change)="filterByStatus()"> -->
                <select class="form-control" style="flex: 0.2; margin-right: 10px;" [(ngModel)]="selectedStatus"
                    (change)="filterCoursesByStatus()">

                    <option value="">Seleccione status</option>
                    <option value="borrador">Borrador</option>
                    <option value="revisión">Revisión</option>
                    <option value="publicado">Publicado</option>
                </select>
                <button *ngIf="search || selectedStatus" class="btn btn-danger"
                    style="white-space: nowrap; margin-right: 10px;" (click)="clearSearch()">
                    Borrar Filtro
                </button>
            </div>
            <div class="d-flex">
                <a class="btn btn-primary btn-sm" style="white-space: nowrap;" (click)="openAddCourseModal(modal)">
                    <span>Agregar</span>
                </a>
            </div>
        </div>
    </div>
</div>

<!-- Loading Spinner -->
<div *ngIf="loading" class="d-flex flex-column justify-content-center align-items-center" style="min-height: 300px;">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
        <span class="sr-only">Cargando...</span>
    </div>
    <p class="mt-3 text-muted">Cargando cursos...</p>
</div>

<!-- Tabla de cursos -->
<div class="table-template" *ngIf="!loading && paginatedCourses.length > 0">
    <table class=" table table-lg table-hover row-border hover">
        <thead>
            <tr>
                <!-- <th>Imagen</th> -->
                <th style="width: 15%;">Título</th>
                <th style="width: 15%;" *ngIf="!isInstructor">Instructor</th>
                <th style="width: 10%;">Precio</th>
                <th style="width: 15%;">Categoría</th>
                <th style="width: 10%;">Nivel</th>
                <th style="width: 10%;">Status</th> <!-- Nueva columna -->
                <!-- <th style="width: 10%;">Total de horas</th> -->
                <th style="width: 10%;">Acciones</th>
            </tr>
        </thead>
        <tbody>
            <!-- <tr *ngFor="let course of product_list"> -->
            <!-- <td><img width="80px" height="auto" [src]="course.ImgFileUrl"></td> quite img-->
            <!-- <tr *ngFor="let course of filteredProductList"> -->
            <tr *ngFor="let course of paginatedCourses" [hidden]="course.Active === false">
                <td>{{course.Title}}</td>
                <td *ngIf="!isInstructor">{{course.user?.displayName || 'Sin instructor'}}</td>
                <td>{{course.UnitPrice| currency:'MXN':'symbol-narrow':'1.2-2' }}</td>
                <td>{{course?.Category?.ValueAlpha}}</td>
                <td>{{course?.Level?.ValueAlpha}}</td>
                <td>
                    <button disabled class="btn btn-sm" [ngClass]="{
                            'btn-success': course.Status?.toLowerCase() === 'published' || course.Status?.toLowerCase() === 'publicado',
                            'btn-warning': course.Status?.toLowerCase() === 'review' || course.Status?.toLowerCase() === 'revision' || course.Status?.toLowerCase() === 'revisión',
                            'btn-secondary': course.Status?.toLowerCase() === 'draft' || course.Status?.toLowerCase() === 'borrador',
                            'btn-light': !course.Status
                        }">
                        {{
                        (course.Status?.toLowerCase() === 'draft' || course.Status?.toLowerCase() === 'borrador')
                        ? 'Borrador'
                        : (course.Status?.toLowerCase() === 'review' || course.Status?.toLowerCase() === 'revision' || course.Status?.toLowerCase() === 'revisión')
                        ? 'Revisión'
                        : (course.Status?.toLowerCase() === 'published' || course.Status?.toLowerCase() === 'publicado')
                        ? 'Publicado'
                        : 'Sin status (' + course.Status + ')'
                        }}
                    </button>
                </td>

                <!-- <td>{{course.status ? 'Publicado' : 'Revisión'}}</td> Estado del curso -->
                <!-- <td>{{course.TotalHours}}</td> -->
                <td class="actions-cell">
                    <div ngbDropdown class="d-inline-block">
                        <button class="btn btn-sm btn-light" type="button" [id]="'dropdownMenuButton' + course.id" 
                                ngbDropdownToggle>
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <div ngbDropdownMenu [attr.aria-labelledby]="'dropdownMenuButton' + course.id">
                            <a class="dropdown-item" [routerLink]="['/products/product-detail', course.id]" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">remove_red_eye</mat-icon>
                                Ver detalle
                            </a>
                            <a class="dropdown-item" 
                               *ngIf="course.Status?.toLowerCase() === 'draft' || course.Status?.toLowerCase() === 'borrador'"
                               href="javascript:void(0);" 
                               (click)="openEditCourseModal(editModal, course.id)" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">edit</mat-icon>
                                Editar
                            </a>
                            <a class="dropdown-item" [routerLink]="['/products/add-quiz', course.id]" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">quiz</mat-icon>
                                Cuestionarios
                            </a>
                            <a class="dropdown-item" [routerLink]="['/products/product-landing', course.id]" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">ballot</mat-icon>
                                Landing page
                            </a>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="copiarURL(course.Slug)" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">content_copy</mat-icon>
                                Copiar URL
                            </a>
                            <a class="dropdown-item" 
                               *ngIf="course.Status?.toLowerCase() === 'draft' || course.Status?.toLowerCase() === 'borrador'" 
                               href="javascript:void(0);" 
                               (click)="sendToReview(course.id)" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">send</mat-icon>
                                Enviar a revisión
                            </a>
                            <div class="dropdown-divider" *ngIf="course.Status?.toLowerCase() !== 'published' && course.Status?.toLowerCase() !== 'publicado'"></div>
                            <a class="dropdown-item text-danger" 
                               *ngIf="course.Status?.toLowerCase() !== 'published' && course.Status?.toLowerCase() !== 'publicado'" 
                               href="javascript:void(0);" 
                               (click)="confirmDelete(course.id)" ngbDropdownItem>
                                <mat-icon class="align-middle mr-2" style="font-size: 18px; width: 18px; height: 18px;">delete</mat-icon>
                                Eliminar
                            </a>
                        </div>
                    </div>
                      
                      
                                                    
                    <!-- <div class="opciones">/products/courses
                        Opciones <i class="fa fa-caret-down ml-1" aria-hidden="true"></i> <br>

                        <ul>
                            <li [routerLink]="['show', course.id]">Ver curso</li>
                            <li [routerLink]="['edit', course.id]">Editar curso</li>
                            <li [routerLink]="['view-programs', course.id]">Agregar y/o ver módulos</li>
                            <li>{{course.Active === true ?
                                'Ocultar' : 'Publicar'}}</li>
                            <li>Previsualizar curso</li>
                        </ul>
                    </div> -->
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- Mensaje cuando no hay resultados -->
<div *ngIf="!loading && paginatedCourses.length === 0" class="text-center py-5">
    <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #ccc;">school</mat-icon>
    <h4 class="mt-3 text-muted">No se encontraron cursos</h4>
    <p class="text-muted">
        <span *ngIf="search || selectedStatus">Intenta ajustar los filtros de búsqueda.</span>
        <span *ngIf="!search && !selectedStatus">Aún no tienes cursos creados.</span>
    </p>
    <button *ngIf="search || selectedStatus" class="btn btn-primary mt-2" (click)="clearSearch()">
        Limpiar filtros
    </button>
    <button *ngIf="!search && !selectedStatus" class="btn btn-primary mt-2" (click)="openAddCourseModal(modal)">
        Crear primer curso
    </button>
</div>

<!-- Controles de paginación -->
<div class="pagination-controls d-flex justify-content-center align-items-center mt-4" *ngIf="!loading && paginatedCourses.length > 0 && totalPages > 1">
    <nav aria-label="Paginación">
        <ul class="pagination mb-0">
            <li class="page-item" [class.disabled]="currentPage === 1">
                <a class="page-link" (click)="previousPage()" aria-label="Anterior">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            
            <li class="page-item" *ngFor="let page of getPageNumbers()" [class.active]="page === currentPage">
                <a class="page-link" (click)="goToPage(page)">{{page}}</a>
            </li>
            
            <li class="page-item" [class.disabled]="currentPage === totalPages">
                <a class="page-link" (click)="nextPage()" aria-label="Siguiente">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
    <div class="text-muted small ms-3">
        Página {{currentPage}} de {{totalPages}} ({{totalProducts}} cursos totales)
    </div>
</div>

<!-- Modal para crear nuevo curso -->
<ng-template #modal let-modal class="modal-dialog">
        <div class="text-center">
            <div class="modal-header justify-content-end">
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
            </div>
            <h5 class="modal-title">¿Deseas asesoría para estructurar tu curso?</h5>
            <div class="modal-footer">
                <a class="btn btn-primary btn-lg" (click)="modal.close()" [routerLink]="['add-course']" 
                    [queryParams]="{ mode: 'con' }">
                    Sí, quiero asesoría
                </a>
                <a class="btn btn-secondary btn-lg" (click)="modal.close()" [routerLink]="['add-course']"
                    [queryParams]="{ mode: 'sin' }">
                    No, continuar sin asesoría
                </a>
            </div>
        </div>
    </ng-template>

    <!-- Modal para editar curso existente -->
    <ng-template #editModal let-modal class="modal-dialog">
        <div class="text-center">
            <div class="modal-header justify-content-end">
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
            </div>
            <h5 class="modal-title">¿Cómo deseas continuar editando tu curso?</h5>
            <p class="text-muted mt-2">Selecciona el modo de edición que prefieras</p>
            <div class="modal-footer">
                <a class="btn btn-primary btn-lg" (click)="modal.close()" [routerLink]="['edit', selectedCourseId]" 
                    [queryParams]="{ mode: 'con' }">
                    Con asesoría
                </a>
                <a class="btn btn-secondary btn-lg" (click)="modal.close()" [routerLink]="['edit', selectedCourseId]"
                    [queryParams]="{ mode: 'sin' }">
                    Sin asesoría
                </a>
            </div>
        </div>
    </ng-template>